export default "/images/type-italic.svg?ead7669be6a051a51bd19db399b57b93";